import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { motion, AnimatePresence } from "framer-motion";

import { LinkButton } from "../../../globals/components/button";


import background from "../assets/background.png";

import { Scale } from 'react-scaling';

import hatText from '../assets/hats.txt';
import clothesText from '../assets/clothes.txt';
import glovesText from '../assets/gloves.txt';
import accessoriesText from '../assets/accessories.txt';

import mergeImages from 'merge-images';


const Background = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
  background-image: url(${background});
  background-repeat: no-repeat;
  background-size: cover;
  border-right: 2px solid #79559a;
`;

/* The Modal (background) */
const ModalBG  = styled.div`
  position: absolute;
  z-index: 1; /* Sit on top */
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const BuyBehind = styled.div`
  background-image: url(${process.env.PUBLIC_URL}/cosmetics/shop_ui/buy_behind.png);
  background-size: cover;
`

const BuyInfront = styled.div`
  background-image: url(${process.env.PUBLIC_URL}/cosmetics/shop_ui/buy_infront.png);
  background-size: cover;
  z-index: -1;
`


const WhiteBackground = styled.div`
  width: 1280px;
  height: 720px;
  background: white;
  position: fixed;
  top: 10%;
`;

const ShopIcon = styled.div`
  background-image: url(${process.env.PUBLIC_URL}/cosmetics/shop_ui/type_button.png);
`


const ShopColumn = styled.div`
  flex: 76%;
  padding: 4%;
  height: 80%;

  ::-webkit-scrollbar {
    width: 20px;
    }
`


const ShopItem = styled.img`
  user-select: none;
  cursor: pointer;

`

const LockedShopItem = styled.img`
  user-select: none;
  cursor: pointer;
`



export default function ShopContainer(props) {

  const variants = {
    open: {
      top: "10%",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 0,
      }
    },
    closed: {
      top: "100%",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 1.5
      }
    }
  };

  const blockerVariants = {
    show: {
      opacity: 1,
      display: "flex",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 1.5,
      }
    },
    hide: {
      opacity: 0,
      display: "none",
      transition: {
        type: "spring",
        bounce: 0,
        duration: 1.5
      }
    }
  };

  console.log(props);

  const [selectedShop, setSelectedShop] = useState("");
  const [currentCosmetics, setCurrentCosmetics] = useState ([]);
  const [mustWait, setMustWait] = useState(false);
  const [selectedCosmetic, setSelectedCosmetic] = useState(null);
  var totalCosmetics = 99999;

  
  useEffect(() => {
    if (selectedShop != "" && mustWait == false){
      console.log("SELECTED:"+selectedShop);
      setCurrentCosmetics([]);
      setMustWait(true);
    }
  }, [selectedShop, props.tamagotchi])


  useEffect(() => {
    if (currentCosmetics != null && currentCosmetics.length == 0){
      totalCosmetics = 0;

      let currentFile = null;
      if (selectedShop == "hats"){
        currentFile = hatText;
      }else if (selectedShop == "clothes"){
        currentFile = clothesText;
      }else if (selectedShop == "accessories"){
        currentFile = accessoriesText;
      }else if (selectedShop == "gloves"){
        currentFile = hatText;
      }
      else{
        console.log("break here");
        return;
      }

      var promises = [];

      fetch(currentFile)
      .then(r => r.text())
      .then(text => {
        let lines = text.split('\n');
        lines.forEach(element => {
          if (element != ""){
            let id = element.replace("\r", "").split("|")[0];
            //console.log(id);
            let owned = CheckIfOwned(id);
            let price = element.replace("\r", "").split("|")[1];
            if (owned == true){
              if (CheckIfEquipped(id)){
                promises.push(mergeImages(['/cosmetics/shop_ui/equipped_cosmetic.png', '/cosmetics/previews/'+id+".png" , '/cosmetics/shop_ui/buy_infront.png']).then(b64 => AddCosmeticPreview(b64, id, owned, price)));
              }else{
                promises.push(mergeImages(['/cosmetics/shop_ui/buy_behind.png', '/cosmetics/previews/'+id+".png" , '/cosmetics/shop_ui/buy_infront.png']).then(b64 => AddCosmeticPreview(b64, id, owned, price)));
              }
            }else{
              promises.push(mergeImages([
                {src: '/cosmetics/shop_ui/buy_behind.png', x: 0, y: 0}, 
                {src:'/cosmetics/previews/'+id+".png" , x:0, y: 0},
                {src:'/cosmetics/shop_ui/buy_infront.png',x:0,y:0}, 
                {src:'/cosmetics/shop_ui/lock_button.png', x:0, y: 0}
              ]).then(b64 => AddCosmeticPreview(b64, id, owned, price)));
            }
          }
        });
      Promise.all(promises).then(() => {
        setMustWait(false);
      });
      
      });
    }else{
      
    }
  }, [currentCosmetics])

  function CheckIfEquipped(id){
    if (props.tamagotchi != null){
      let equippedItems = JSON.parse(props.tamagotchi.equipped_items);
      //console.log("Check if Equipped");
      console.log(equippedItems);
      //console.log(id);
      if (equippedItems != null){
        if (equippedItems.clothesId != undefined && equippedItems.clothesId == id){
          return true;
        }else if(equippedItems.hatId != undefined && equippedItems.hatId == id){
          return true;
        }else if (equippedItems.accessoriesId != undefined && equippedItems.accessoriesId == id){
          return true;
        }
      }
    }
      return false;
  }


  function CheckIfOwned(id){
    if (props.ownedItems == null) return false;

    for (let i = 0; i < props.ownedItems.length; i++) {
      const cosmetic = props.ownedItems[i];
      if (cosmetic.accessory_key == id){
        return true;
      }
    }
    return false;
  }
  

  

  function AddCosmeticPreview(preview, id, owned, price){
    let cosmeticData = {
      id: id,
      image: preview,
      owned: owned, 
      price: price
    }
    setCurrentCosmetics((prevItems) => [
      ...prevItems,
      cosmeticData,
    ]);
  }


  function RenderCosmetics(){

    console.log(currentCosmetics);

    

    if (currentCosmetics != null && currentCosmetics.length > 0){
        return (
          <div tamagotchi={props.tamagotchi}>
            {currentCosmetics.map((cosmetic) => (
            cosmetic.owned == true
              ? ReturnShopItem(cosmetic)
              : ReturnLockedShopItem(cosmetic)
            ))}

          </div>
    );
    }else{
      return (
        <div></div>
      );
    }
    
  }


  function SelectShopItem(cosmetic){
    console.log("selecting: " + cosmetic.id)
    setSelectedCosmetic(cosmetic.id);
    //do something else in the use effect making the buy/equip button appear
  }

  function ReturnShopItem(cosmetic){
    //outline: #e88f12 solid 3px;

    if (selectedCosmetic == cosmetic.id){
      return (
        <ShopItem style={{outline: "#e88f12 solid 3px"}} src={cosmetic.image}></ShopItem>
      );
    }else{
      return (
        <ShopItem onClick={() => {SelectShopItem(cosmetic);}} src={cosmetic.image}></ShopItem>
      );
    }
    
  }

  function ReturnLockedShopItem(cosmetic){
    if (selectedCosmetic == cosmetic.id){
      return (
        <LockedShopItem style={{outline: "#e88f12 solid 3px"}} src={cosmetic.image}></LockedShopItem>
      );
    }else{
      return (
        <LockedShopItem onClick={() => {SelectShopItem(cosmetic);}} src={cosmetic.image}></LockedShopItem>
      );
    }
  }

  useEffect(() => {
    if (props.showShop == true){
      console.log("opening the shop");
      SelectShop("hats");
    }
  }, [props.showShop])



  function CosmeticPrice(){
    for (let i = 0; i < currentCosmetics.length; i++) {
      const cosmetic = currentCosmetics[i];
      if (cosmetic.id == selectedCosmetic){
        return cosmetic.price;
      }
    }
    return 1000;
  }
  

function GetButtonName(){
  if (selectedCosmetic != null){
    console.log(selectedCosmetic);
    if (CheckIfOwned(selectedCosmetic) == true){
      return "Equip";
    }else{
      return "Buy " + CosmeticPrice();
    }
      
  }
  return "";
}

function BuyOrEquipCosmetic(){
  let owns = CheckIfOwned(selectedCosmetic);
  let price = CosmeticPrice();
  if (owns ){
    console.log("Equip " + selectedCosmetic);
    props.UpdateTamagotchi(selectedCosmetic);
  }else{
    props.BuyItem(selectedCosmetic, price);
    console.log("Buy " + selectedCosmetic);
  }
}

function CanAfford(){
  if (selectedCosmetic != null && CheckIfOwned(selectedCosmetic)){
    //console.log("you own this item");
    return true;
  }
  if (props.coins >= CosmeticPrice()){
    //console.log("you can afford this item");
    return true;
  }else{
    //console.log("not enough coins for this item");
    return false;
  }
}
  

  function SelectShop(type){
      setSelectedCosmetic(null);
      setSelectedShop(type);
  }

  //<Button selected={selectedShop === "gloves"} disabled style={{width: "200px"}} onClick={() => {SelectShop("gloves");}}>Gloves</Button>


  return (
  <AnimatePresence>
    <ModalBG as={motion.div} variants={blockerVariants} style={props.style} animate={props.showShop ? "show": "hide"}>
      
        <WhiteBackground as={motion.div} variants={variants} style={props.style} animate={props.showShop ? "open": "closed"}>
          <Background>
            <ShopColumn>
              <img style={{pointerEvents: "none", transform: "scale(0.7)", position: "absolute", right: "33%", top: "0%"}}src={props.tamaImage}></img>
            </ShopColumn>
            
            <ShopColumn tamagotchi={props.tamagotchi} style={{overflow: "auto"}} selectedCosmetic={selectedCosmetic} cosmetics={currentCosmetics}>
              {RenderCosmetics()}
            </ShopColumn>
            <ShopColumn>
              <Button selected={selectedShop === "hats"} style={{width: "200px"}} onClick={() => {SelectShop("hats");}}>Hats</Button>
              <Button selected={selectedShop === "clothes"} style={{width: "200px"}} onClick={() => {SelectShop("clothes");}}>Clothes</Button>
              <Button selected={selectedShop === "accessories"} style={{width: "200px"}} onClick={() => {SelectShop("accessories");}}>Accessories</Button>
              
              <div style={{fontSize: "30px"}}><img style={{pointerEvents: "none", height: "80px"}} src="\cosmetics\shop_ui\chest.png"></img>{props.coins}</div>
              <br/>
              <Button style={{display: selectedCosmetic != null ? '': "none", width: "200px"}} disabled={CanAfford() == true ? "" : "true"} onClick={() => {BuyOrEquipCosmetic()}}>{GetButtonName()}</Button>
              <br/>
              <Button style={{background: "red", padding: "0", width: "100px"}}
                onClick={() => {
                props.setShowShop(false); }}
              >Back</Button>
            </ShopColumn>
          </Background>
        </WhiteBackground>
    </ModalBG>
    </AnimatePresence>
  );
}

const Button = styled.button`
    font-size: 2em;
    background: ${props => (props.selected ? "#43275b" : "rgb(234, 146, 19)")};
    border: 2px solid #e88f12;
    color: #fff;
    user-select: none;
    padding: 0.25em 2.5em;
    margin: 1em 0;
    box-sizing: border-box;
    border-radius: 0.25em;
    cursor: pointer;
    @media (min-width: 1025px) and (max-width: 1440px) {
        font-size: 2em;
    }
    height: 65px;

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {
        margin: 0;
    }

    &:disabled: ${({ disabled }) => (disabled ? true : false)};
    filter: ${({ disabled }) => !disabled ? 'grayscale(0)' : 'grayscale(1)'};
    cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')}; 
    
`;
